/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

require('jquery')
require('@rails/ujs').start()
require('lightbox2')

import 'bootstrap'

import './stylesheets/application'
import './tools/googleMaps.js'

// Check if FB user is logged in
function checkLoginState() {
    FB.getLoginStatus(function(response) {
        if(response.authResponse) {
            window.location = '/users/auth/facebook/callback';
        }
    });
}

window.checkLoginState = checkLoginState

$(function() {
    $('#videoModal').on('hidden.bs.modal', function(e) {
        // Resets the src attribute so the video stops playing
        // when the modal is hidden.
        var src = $('#videoFrame').attr('src');
        $('#videoFrame').attr('src', src);
    });
})

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

